/**
 * Loan Applications Page
 */
import React from 'react';

const LoanApplications = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Loan Applications</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Manage pending loan applications</p>
    </div>
  );
};

export default LoanApplications;
